import React from "react";
import { useExternalStatus } from "@/hooks";
import { cn } from "@/lib/format";

// Server-checked (not client-pinged) connectivity indicator for the external
// Cardano data API — polls this job's own /api/external-status proxy, which
// avoids browser CORS issues and gives a more trustworthy reachability signal.
export const ExternalStatusBadge = () => {
  const { online, apiStatus } = useExternalStatus();

  const LABELS = {
    online: "online",
    sync_stalled: "reachable · sync paused",
    db_down: "database down",
    unreachable: "status unknown",
  };
  const label = apiStatus === null ? "checking…" : LABELS[apiStatus] || "status unknown";
  const dotColor = apiStatus === null
    ? "bg-yellow-400"
    : apiStatus === "online"
    ? "bg-emerald-400"
    : apiStatus === "sync_stalled"
    ? "bg-amber-400"
    : apiStatus === "db_down"
    ? "bg-red-500"
    : "bg-slate-400";

  return (
    <div
      data-testid="external-api-status-badge"
      className="inline-flex items-center gap-2 border border-primary/15 bg-card/40 rounded-full px-3 py-1.5"
    >
      <span className="relative inline-flex h-2 w-2">
        {online ? (
          <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping", dotColor)} />
        ) : null}
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", dotColor)} />
      </span>
      <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mono">
        ada.api.gridscan.io · {label}
      </span>
    </div>
  );
};
